import { render, staticRenderFns } from "./AnswerHistory.vue?vue&type=template&id=02b99a49&scoped=true&"
import script from "./AnswerHistory.vue?vue&type=script&lang=ts&"
export * from "./AnswerHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b99a49",
  null
  
)

export default component.exports